<template>
  <div class="rightBlock journeyTabC">
  <el-container>
    <el-main>
      <div class="tab" style="display: block;">
        <buttonPaneC ref="childJourneyc"></buttonPaneC>

        <div class="channel">
            <div tip>{{$t("journeyTab.tip")}}</div>
          
            <div op>
              <div info>
                <p>{{$t("journeyTab.info")}}</p>
                <ul>
                  <li>{{$t("journeyTab.s1")}}</li>
                  <li>{{$t("journeyTab.s2")}}</li>
                  <li>{{$t("journeyTab.s3")}}</li>
                  <li>{{$t("journeyTab.s4")}}</li>
                  <li>{{$t("journeyTab.s5")}}</li>
                </ul>
              </div>

              <!-- <el-switch
                v-model="autoJourney"
                active-text=""
                inactive-text="显示实时行程高度">
              </el-switch> -->
              
              <el-radio-group v-model="showAdcAndHall">
                <el-radio :label="1">{{$t("journeyTab.showHall")}}</el-radio>
                <el-radio :label="2">{{$t("journeyTab.showAdc")}}</el-radio>
              </el-radio-group>

              <!-- <p alljp>{{$t("journeyTab.setAll")}}</p>
              <div class="block" style="padding: 0 25px;">
                <el-slider v-model="performanceNum" @change="setperformanceNum" max="1" step="0.02" format-tooltip="mmVal" show-input width="200px"> </el-slider>
              </div> -->

            </div>
            <div chart>
                <div kedubgc :style="{height: zHeightDefine + 'px',backgroundColor: zMaxAnimationHeightBgColorDefine,}"></div>
                <div kedu></div>
                <div status>
                    <div :style="{'background':'url(' + axisCurZ_B + ') no-repeat','background-size':'cover'}"  animation><img :style="{top: zTopDefine + 'px' }" :src="axisCurZ_Y" width="110" /></div>
                </div>
                <div calibration>
                    <el-button v-on:click="autoCalibration" type="buttonType" round>{{autoName}}</el-button>

                    <el-button v-on:click="manualCalibration" type="buttonType" round>{{manualName}}</el-button>
                </div>
            </div>
        </div>
      </div> 
    </el-main>
  </el-container>
</div>
</template>
<script>
//获取主题配置文件
import cmd10 from '../../../../theme/cmd1.0.config.json';

import buttonPaneC from './buttonTabPane/journeyProduct.vue'
export default {
  name: 'performanceTabC',
  components: 
  {
    buttonPaneC
  },
  data() {

    return {
      ThemeConf:null,
      HIDDeviceObj:null,
      autoCalibrate:false,
      autoName: this.$i18n.t("journeyTab.activeAuto"),
      manualCalibrate:false,
      manualName: this.$i18n.t("journeyTab.activeManual"),
      buttonType: '',//warning
      autoJourney:true,
      performanceNum:0.2,
      showAdcAndHall:1,
      RealTimeJourneyVal:0,
      zMaxJourneyDefine:4000,

      zTopDefine:-43,
      zMaxAnimationDefine:31,

      zHeightDefine:0,
      zMaxAnimationHeightDefine:240,
      zMaxAnimationHeightBgColorDefine:'#e1e1e1',
      axisCurZ_Y:"",
      axisCurZ_B:""
    }
  },
  mounted() 
  {


  },
  methods: 
  {
      //自定义轴体
      axisCur(brand,model,rt,maxHigth)
      {
        if(brand == "" || model == "")
        {
            this.axisCurZ_Y =  require("../asserts/image/z_y.png");
            this.axisCurZ_B =  require("../asserts/image/z_b.png");
        }
        else
        {
          try 
          {
            // 尝试导入资源
            this.axisCurZ_Y =  require("../asserts/image/axis/"+ brand +"/" + model +"/z_y.png");
            this.axisCurZ_B =  require("../asserts/image/axis/"+ brand +"/" + model +"/z_b.png");
            // localStorage.setItem('axis',JSON.stringify({"brand":brand,"model":model,"rt":rt,"maxHigth":maxHigth}));

          } catch (e) 
          {
            // 资源不存在，捕获错误
            console.error(`资源不存在`);

            this.axisCurZ_Y =  require("../asserts/image/z_y.png");
            this.axisCurZ_B =  require("../asserts/image/z_b.png");
          }
        }
      
      },
      
      //初始化配置数据
      initData()
      {
        for(let i in this.ThemeConf.DeviceList)
        {
            if(this.ThemeConf.DeviceList[i].FirmwareVer == this.HIDDeviceObj.FirmwareVer)
            {
              if(this.ThemeConf.axisSet.brand != '')
              {
                this.axisCur(this.ThemeConf.axisSet.brand,
                this.ThemeConf.axisSet.model,
                this.ThemeConf.axisSet.rt,
                this.ThemeConf.axisSet.maxHigth);
              }
              else
              {
                this.axisCur(this.ThemeConf.DeviceList[i].axis.brand,
                this.ThemeConf.DeviceList[i].axis.model,
                this.ThemeConf.DeviceList[i].axis.rt,
                this.ThemeConf.DeviceList[i].axis.maxHigth);
              }
              
              break;
            }
        }
      },
      //初始化刷新数据
      init()
      {
        const ChildProductBottonC = this.$refs.childJourneyc;
              ChildProductBottonC.KeyMap = this.HIDDeviceObj.MatrixList.KeyMap;
              ChildProductBottonC.HIDDeviceObj = this.HIDDeviceObj;
              ChildProductBottonC.setProductImagePath();

          // this.RealTimeJourneyVal = this.HIDDeviceObj.curMaxJourney.toFixed(3);
          // this.RealTimeJourneyVal = this.HIDDeviceObj.curMaxJourney + (0.2/38)*(this.HIDDeviceObj.curMaxJourney*10);
          // this.RealTimeJourneyVal = this.RealTimeJourneyVal>4?4:this.RealTimeJourneyVal;
          this.RealTimeJourneyVal = this.HIDDeviceObj.curMaxJourney.toFixed(3);
          this.zMaxAnimationHeightBgColorDefine = this.HIDDeviceObj.curMaxJourneyKeyStatus>1?'#75c54d':'#e1e1e1';

          this.setZTop();
          this.refreshData(this.HIDDeviceObj.MatrixList.KeyMap);
      },
      setZTop()
      {
          let minTop = this.zMaxAnimationDefine/this.zMaxJourneyDefine;
          this.zTopDefine = -43 + this.RealTimeJourneyVal*1000*minTop;
          this.zTopDefine = this.zTopDefine>this.zMaxAnimationDefine?-43:this.zTopDefine;

          //高度
          let minHeight = this.zMaxAnimationHeightDefine/this.zMaxJourneyDefine;
          this.zHeightDefine = this.RealTimeJourneyVal*1000*minHeight;
          this.zHeightDefine = this.zHeightDefine>this.zMaxAnimationHeightDefine?0:this.zHeightDefine;
      },
      // 实时刷新按键状态
      refreshData(mapData)
      {
          for(let i=0;i<mapData.length;i++)
          {
            for(let j=0;j<mapData[i].length;j++)
            {
                let bottonObj = mapData[i][j];
                let keyName = bottonObj.key_name;
                if(keyName == 0)
                    continue;

                let button = document.querySelector('.journeyP li[name='+ keyName +']');

                if(!button)
                    continue;

                let val = (this.showAdcAndHall == 1)?(bottonObj.journey/1000).toFixed(2):bottonObj.adc_data;
                    val = (typeof val == "undefined")?0:val;

                    button.setAttribute("journey",val);


                if(bottonObj.key_status == 2)
                {
                  button.classList.remove('calibration');
                  button.classList.add("ok");
                }

                //自动校准状态
                if(val == 0.00 && this.autoCalibrate)
                {
                    setTimeout(()=>{

                      button.classList.remove('calibration');
                      button.classList.add("ok");

                    },20*i*j);
                }
                else if(val != 0.00 && this.autoCalibrate)
                {
                      button.classList.remove('ok');
                      button.classList.add("calibration");
                }

            }
          }
      },
      setperformanceNum(val)
      {
        this.performanceNum = val==0?0.2:val;
      },
      mmVal(val)
      {
        return val+"mm";
      },
      stopCalibrate()
      {
        this.HIDDeviceObj.stopCalibrate(cmd10);
        this.calibrate = false;
        this.activeName =  this.$i18n.t("journeyTab.activeStart");
        this.buttonType =  '';

        let buttons = document.querySelectorAll("li");
        buttons.forEach(function(el) 
        {
            el.classList.remove('calibration');
            el.classList.remove('ok');
        });
      },
      //手动校准
      manualCalibration()
      {
          this.HIDDeviceObj.stopListening();
          // this.HIDDeviceObj.stopCalibrate(cmd10);
          this.$notify.closeAll();

          let buttons = document.querySelectorAll("li");
              buttons.forEach(function(el) 
              {
                  el.classList.remove('ok');
              });


          this.manualCalibrate = !this.manualCalibrate;
          if(this.manualCalibrate)
          {
              this.$notify({duration:0,offset: 120,title: this.$i18n.t("journeyTab.activeManual"), message: this.$i18n.t("journeyTab.activeWarnMsg"),type: 'warning'});
              this.manualName =  this.$i18n.t("journeyTab.activeStop");
              this.HIDDeviceObj.startCalibrate(cmd10);
          }
          else
          {
              this.HIDDeviceObj.stopCalibrate(cmd10);
              this.manualName =  this.$i18n.t("journeyTab.activeManual");
              this.buttonType =  '';
          }
      },
      
      //自动校准动画
      autoCalibrationAnimation(JourneyVal)
      {
          //动画
          let minTop = this.zMaxAnimationDefine/this.zMaxJourneyDefine;
          this.zTopDefine = -43 + JourneyVal*1000*minTop;
          this.zTopDefine = this.zTopDefine>this.zMaxAnimationDefine?-43:this.zTopDefine;
      },
      //自动校准
      autoCalibration()
      {
        let animationVal = 0.1;
        let animationId =setInterval(()=>{

            animationVal = 4;
            this.autoCalibrationAnimation(animationVal);

        },120);


        this.showAdcAndHall = 1;
        this.HIDDeviceObj.stopListening();
        if(!this.autoCalibrate)
        {
          let buttons = document.querySelectorAll("li");
              buttons.forEach(function(el) 
              {
                  el.classList.remove('calibration');
                  el.classList.remove('ok');
              });

          this.HIDDeviceObj.stopCalibrate(cmd10);
          this.autoCalibrate = true;
          this.$notify({duration:0, offset: 120,title: this.$i18n.t("journeyTab.activeAuto"), message: this.$i18n.t("journeyTab.activeMsg"),type: 'warning'});

          this.autoName =  this.$i18n.t("journeyTab.activeStop");
          this.buttonType =  'warning';
          this.HIDDeviceObj.startListeningNormal(cmd10);
          setTimeout(()=>
          {
            this.autoCalibrate = false;
            this.HIDDeviceObj.stopListening();
            this.autoName =  this.$i18n.t("journeyTab.activeAuto");
          
            clearInterval(animationId);

          },1000);

          setTimeout(()=>{this.$notify.closeAll();},3000)
        }
        // else
        // {
        //   this.autoCalibrate = false;
        //   this.HIDDeviceObj.stopListening();
        //   this.autoName =  '自动校准';
        //   this.$notify.closeAll();
        //   this.buttonType =  '';
        //   buttons.forEach(function(el) 
        //   {
        //       el.classList.remove('calibration');
        //       el.classList.remove('ok');
        //   });
        // }

      }
  },
  computed: 
  {
      
  }
}

</script>